import React from 'react';
import { Heading } from '@chakra-ui/react';
import i18next from 'i18next';

import APP_CONFIG from '@/app.config';
import Icon from '@/components/0-reusable-components/icon';
import Authorized from '@/components/all-providers/authorized';
import FeatureFlag from '@/components/all-providers/feature-flag';
import { MenuItem } from '@/menu.config';

import ListItem from './drawer-list-item';

type Props = { isOpen: boolean; onClose: () => void };
type SectionProps = { headerText: string; navItems: MenuItem[]; onClose: () => void };

const DrawerSection = ({ headerText, navItems, onClose }: SectionProps): React.ReactElement => (
  <>
    <Heading key={headerText} size='sm' isTruncated px='30px' py='16px'>
      {headerText}
    </Heading>
    {navItems.map((menuItem) => (
      <Authorized key={menuItem.key} requiredRoles={menuItem.requiredRoles || []}>
        <FeatureFlag requiredFlags={menuItem.requiredFeatureFlags || []}>
          <ListItem
            key={menuItem.key}
            href={menuItem.path}
            leftIcon={<Icon name={menuItem.icon || menuItem.key} />}
            primaryText={i18next.t(menuItem.label)}
            onClose={onClose}
          />
        </FeatureFlag>
      </Authorized>
    ))}
  </>
);

const DrawerItems = ({ onClose }: Props): React.ReactElement | null => {
  return (
    <>
      {Object.keys(APP_CONFIG.menu).map((section: string, index: number) => (
        <DrawerSection
          key={`section_${index}`}
          headerText={i18next.t(section)}
          navItems={APP_CONFIG.menu[section]}
          onClose={onClose}
        />
      ))}
    </>
  );
};

export default DrawerItems;
